<template>
  <div class="warehouse-reference-wrapper">
    <div class="d-flex justify-lg-space-between align-center">
      <div class="d-flex flex-wrap mb-5">
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div class="info-wrap-status-box grey"></div>
            <div class="info-wrap-status-txt">
              {{ $t("warehouseFieldType.corridor") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div class="info-wrap-status-box lightSuccess"></div>
            <div class="info-wrap-status-txt">
              {{ $t("warehouseFieldType.stillage") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div class="info-wrap-status-box warning"></div>
            <div class="info-wrap-status-txt">
              {{ $t("warehouseFieldType.field") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div
              class="info-wrap-status-box"
              style="background: #01617f; border-radius: 50%"
            ></div>
            <div class="info-wrap-status-txt">
              {{ $t("allCarriagesEmpty") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div
              class="info-wrap-status-box"
              style="background: #ee6565; border-radius: 50%"
            ></div>
            <div class="info-wrap-status-txt">
              {{ $t("carriagesFull") }}
            </div>
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-wrap-status">
            <div
              class="info-wrap-status-box"
              style="background: #efbd17; border-radius: 50%"
            ></div>
            <div class="info-wrap-status-txt">
              {{ $t("halfEmpty") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-lg-space-between align-center">
      <div class="d-flex flex-wrap mb-5"></div>
    </div>
    <div class="d-flex">
      <div
        ref="wrapper"
        :style="{
          overflow: 'auto',
          maxHeight: $vuetify.breakpoint.height - 385 + 'px',
          maxWidth: '100%',
          width: '100%',
        }"
      >
        <div
          class="warehouse-view-table-navigation warehouse-view-table-navigation-horizontal"
        >
          <warehouse-box
            :key="`letter-${letterIndex}`"
            :width="columnWidth"
            :class="['warehouse-index-top-box']"
            v-for="(columnWidth, letterIndex) in data.columns"
            >{{ getLetter(letterIndex) }}
          </warehouse-box>
        </div>
        <div class="d-flex">
          <div
            class="warehouse-view-table-navigation warehouse-view-table-navigation-vertical"
          >
            <warehouse-box
              :height="columnHeight"
              :key="`row-${index}`"
              v-for="(columnHeight, index) in data.rows"
              :class="['warehouse-index-left-box']"
              >{{ index }}
            </warehouse-box>
          </div>
          <div class="d-flex text-uppercase table-cell-wrapper">
            <div
              v-for="(column, columnIndex) in data.boards"
              :key="columnIndex"
              :class="column.alarm ? 'show_animation_alarm' : ''"
            >
              <warehouse-box
                v-for="(row, index) in column"
                :width="row.width"
                :key="`box-${columnIndex}-${index}`"
                :height="row.height"
                @click="
                  boxClickHandler(
                    row.placeType,
                    row.id,
                    row.columnId,
                    row,
                    $event
                  )
                "
                :class="[
                  'warehouse-view-table-box',
                  `warehouse-view-table-box-${row.placeType.toLowerCase()}`,
                  { show_animation_alarm: trueSet(row.alarm) },
                ]"
                >{{ getLetter(columnIndex) }}{{ index }}
                <span
                  :style="{
                    background: WAREHOUSE_BOX_STATUS[row.stillageColor],
                  }"
                  class="indicator"
                ></span
              ></warehouse-box>
            </div>
          </div>
        </div>
      </div>
      <draggable-dialog
        v-click-outside="closeProductItemInfo"
        ref="draggableDialog"
        :initial-position="{ top: item.top, left: item.left }"
        @onClosed="closeDialog(index)"
        :key="`draggable-dialog-${index}`"
        v-for="(item, index) in productItems"
        v-model="item.dialog"
      >
        <v-card elevation="2" width="500">
          <v-card-title>{{ item.name }}</v-card-title>
          <v-card-text>
            <div class="mb-3">
              <!--            <custom-input-text-->
              <!--                :label="$t('productName')"-->
              <!--                class="user_input no-margin"-->
              <!--            ></custom-input-text>-->
              <div
                style="overflow: auto; max-height: 350px"
                v-if="item.products.length"
              >
                <product-list-in-warehouse :products="item.products" />
              </div>
              <div class="font-weight-bold mt-1" v-else>
                {{ $t("noPlacementProduct") }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </draggable-dialog>
    </div>
  </div>
</template>

<script>
import "./warehouse.css";
import "./warehouse-edit-table.css";
import { FIELD_TYPES, WAREHOUSE_BOX_STATUS } from "@/utils/constants";
import { getLetter } from "@/utils/numeration";
import DraggableDialog from "@/components/ui/draggable-dialog/DraggableDialog";
import ProductListInWarehouse from "@/components/product/ProductListInWarehouse";
import { trueSet } from "@/utils/pureFunctions";
import WarehouseBox from "@/components/warehouse/WarehouseBox.vue";

const FIELD_TYPES_INDEX = FIELD_TYPES.reduce((initial, item) => {
  initial[item.value] = item.value;
  return initial;
}, {});

const BOX_POSITION = {
  col: "col",
  row: "row",
};
export default {
  name: "warehouse-view-table",
  props: {
    data: {
      type: Object,
      required: true,
    },
    stillageRouteName: {
      type: String,
    },
  },
  data() {
    return {
      productItems: [],
    };
  },
  methods: {
    closeProductItemInfo() {
      this.productItems = [];
    },
    async getProducts(cellId) {
      try {
        this.showLoading();
        const {
          data: { data },
        } = await this.$http.get("product-item/get-by-cell", {
          params: { cellId },
        });
        return data;
      } catch (e) {
        this.setResponseError({ error: e });
        return Promise.resolve([]);
      } finally {
        this.clearLoading();
      }
    },
    closeDialog(index) {
      this.productItems[index].dialog = false;
    },
    applyClickHandler() {
      const { positionType, type } = this.currentItem;
      if (type) {
        if (positionType === BOX_POSITION.col) {
          this.data.columnCount++;
          this.data.rows.push([
            {
              placeType: type,
              position: 0,
              name: `${getLetter(this.data.rows.length)}0`,
            },
          ]);
        } else if (positionType === BOX_POSITION.row) {
          const { columnIndex } = this.currentItem;
          this.data.rows[columnIndex].push({
            placeType: type,
            position: this.data.rows[columnIndex].length,
            name: `${getLetter(columnIndex)}${
              this.data.rows[columnIndex].length
            }`,
          });
        }
        this.currentItem.contextMenuVisible = false;
      }
    },
    deleteBoxHandler({ rowIndex, columnIndex }) {
      this.warningDialog = true;
      this.currentItem = { ...this.currentItem, rowIndex, columnIndex };
    },
    reInitBoxPosition({ columnIndex, rowIndex }) {
      if (this.data.rows[columnIndex].length - 1 !== rowIndex) {
        this.data.rows.splice(
          columnIndex,
          1,
          this.data.rows[columnIndex].map((item, index) => {
            item.position = index;
            return item;
          })
        );
      }
    },
    applyBoxDeleteHandler() {
      const { rowIndex, columnIndex } = this.currentItem;
      if (this.data.rows[columnIndex].length === 1) {
        this.data.rows.splice(columnIndex, 1);
      } else {
        this.data.rows[columnIndex].splice(rowIndex, 1);
        this.reInitBoxPosition({ columnIndex, rowIndex });
      }
    },
    async boxClickHandler(type, cellId, columnId, item, event) {
      if (FIELD_TYPES_INDEX.Stillage === type) {
        const warehouseId = this.$route.params.id;
        await this.$router.push({
          name: this.stillageRouteName,
          params: { cellId, columnId, warehouseId },
          query: { productName: this.$route.query.productName },
        });
      } else if (FIELD_TYPES_INDEX.Field === type) {
        const products = await this.getProducts(item.id);
        this.productItems = [
          {
            id: item.id,
            name: item.name,
            dialog: true,
            products,
            top: event.clientY,
            left: event.clientX,
          },
        ];
        // if (productItemIndex === -1) {
        //   this.productItems.push({
        //     id: item.id,
        //     name: item.name,
        //     dialog: true,
        //     products,
        //     top: event.clientY,
        //     left: event.clientX
        //   })
        // } else {
        //   const {draggableDialog} = this.$refs
        //   this.productItems[productItemIndex].dialog = true
        //   draggableDialog[productItemIndex].incrementZIndex()
        // }
      }
    },
  },
  components: {
    WarehouseBox,
    ProductListInWarehouse,
    DraggableDialog,
  },
  computed: {
    WAREHOUSE_BOX_STATUS() {
      return {
        [WAREHOUSE_BOX_STATUS.EMPTY]: "#01617f",
        [WAREHOUSE_BOX_STATUS.FULL]: "#ee6565",
        [WAREHOUSE_BOX_STATUS.HALF_EMPTY]: "#efbd17",
        [WAREHOUSE_BOX_STATUS.NOT_CONFIGURED]: "#01617f",
      };
    },
    FIELD_TYPES() {
      return FIELD_TYPES.map((item) => {
        return {
          text: this.$t(`warehouseFieldType.${item.text}`),
          value: item.value,
        };
      });
    },
    getLetter: () => getLetter,
    trueSet: () => trueSet,
  },
};
</script>

<style scoped lang="scss">
.indicator {
  position: absolute;
  width: 15px;
  height: 15px;
  right: 0;
  top: 0;
  border-radius: 50%;
}
.show_animation_alarm {
  &::before {
    content: "";
    width: 13px;
    position: absolute;
    height: 13px;
    border-radius: 50%;
    background: red;
    opacity: 0.8;
    left: 5px;
    top: 5px;
    animation: pulse 2s linear infinite;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(203, 49, 49, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 100px rgba(112, 33, 33, 0.7);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(203, 49, 49, 0.7);
  }
}
</style>
